import axios from 'axios'
import refreshTokenInterceptor from './refreshToken'

export const axiosPayload = {
  headers: {
    Accept: 'application/json'
  },
  baseURL: process.env.API_URL,
  withCredentials: true
}

const instance = axios.create(axiosPayload)
refreshTokenInterceptor(instance)

export default instance
